import React from "react";
import { Form } from "react-bootstrap";

import { getFieldProps } from "../utils";

const FormTextbox = ({
  formik,
  controlId,
  label,
  password,
  required,
  hint,
  ...props
}) => {
  return (
    <Form.Group controlId={controlId} {...props}>
      <Form.Label>
        {label}
        {required && <span className="text-danger">*</span>}
      </Form.Label>
      <Form.Control
        type={password ? "password" : "text"}
        {...getFieldProps(formik, controlId)}
      />
      {
        hint &&
        <Form.Text className="text-muted">
          {hint}
        </Form.Text>
      }
      <Form.Control.Feedback type="invalid">
        {formik.errors[controlId]}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default FormTextbox;
